export interface ApiResult<T> {
  success: boolean
  data?: T
  message?: string
}

export class ApiError extends Error {
  status: number

  constructor(message: string, status: number) {
    super(message)
    this.status = status
  }
}

export async function apiFetch<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const headers = new Headers(init.headers)
  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }

  const res = await fetch(path, {
    ...init,
    headers,
    credentials: 'include',
  })

  let payload: ApiResult<T> | null = null
  try {
    payload = (await res.json()) as ApiResult<T>
  } catch {
    throw new ApiError('服务器响应无效', res.status)
  }

  if (!res.ok || !payload.success) {
    throw new ApiError(payload.message || '请求失败', res.status)
  }

  return payload.data as T
}
